import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const AppleIconSvg = ({ color = "primary" }) => {
  return (
    <Svg
      fill="none"
      height="33"
      viewBox="-6.2 0 28 17.5"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="m14.5181 12.4689c-.2442.559-.5332 1.0735-.8681 1.5466-.4564.6449-.8302 1.0913-1.1182 1.3392-.4465.4069-.9249.6153-1.4371.6271-.3678 0-.8113-.1037-1.32754-.314-.51795-.2094-.99394-.3131-1.42917-.3131-.45645 0-.946.1037-1.46963.3131-.52442.2103-.94689.32-1.2699.3308-.49124.0208-.98088-.1935-1.46963-.6439-.31195-.2696-.70213-.7318-1.16954-1.3866-.50151-.6993-.91381-1.5101-1.23682-2.4345-.34593-.9985-.51935-1.9654-.51935-2.90146 0-1.07227.23381-1.99708.70213-2.77207.36806-.6225.8577-1.11355 1.47053-1.47403.61282-.36048 1.27498-.54418 1.98807-.55593.39018 0 .90185.1196 1.5377.35465.63406.23585 1.04118.35545 1.21968.35545.13344 0 .58571-.13985 1.35242-.41865.72505-.25856 1.33695-.36562 1.83825-.32345 1.3584.10864 2.379.63929 3.0577 1.59531-1.2149.72946-1.8159 1.75116-1.8039 3.06183.011 1.02091.3847 1.87045 1.1192 2.54505.3329.313.7046.555 1.1182.7269-.0897.2577-.1843.5046-.285.7417zm-3.1155-12.148809c0 .800179-.295 1.547309-.883 2.238849-.70959.8221-1.56788 1.29714-2.49863 1.22218-.01186-.096-.01874-.19703-.01874-.3032 0-.76817.33746-1.59027.93673-2.26245.29919-.340334.6797-.623318 1.14114-.84906.4604-.222373.896-.3453507 1.3056-.36641.0119.106972.0169.213951.0169.320081z"
        fill={color}
      />
    </Svg>
  )
}

export default AppleIconSvg
